import "leaflet-linear-measurement/src/Leaflet.LinearMeasurement.js";
import "leaflet-linear-measurement/sass/Leaflet.LinearMeasurement.scss";

import { useEffect, useState } from "react";

import { Badge } from "reactstrap";
import { Control } from "leaflet";
import { HIPHEN_GREEN } from "../../../constants";
import { setLinearRulerActive } from "../../../actions/resultMap";
import { useDispatch } from "react-redux";

const SYSTEMS = ["metric", "imperial"];

export const LinearRuler = ({ map }) => {
  const dispatch = useDispatch();
  const [system, setSystem] = useState(SYSTEMS[0]);
  useEffect(() => {
    const control = new Control.LinearMeasurement({
      color: HIPHEN_GREEN,
      unitSystem: system,
      show_azimut: true,
    });
    // The plugin measures the azimuth on screen points, so it is off by the
    // map bearing once leaflet-rotate has turned the map
    const screenAzimut = control.getAzimut;
    control.getAzimut = function (a, b) {
      const screen = screenAzimut.call(this, a, b);
      this.lastAzimut = (Math.round(screen - map.getBearing()) + 360) % 360;
      return this.lastAzimut;
    };
    control.addTo(map);
    control.initRuler();
    return () => map.removeControl(control);
  }, [map, system]);

  // Apart from the control: a unit switch remounts it, the ruler stays open.
  useEffect(() => {
    dispatch(setLinearRulerActive(true));
    return () => dispatch(setLinearRulerActive(false));
  }, [dispatch]);

  return (
    <>
      <span>Linear ruler</span>
      <Badge
        className="clickable"
        color="invalid"
        style={{ backgroundColor: HIPHEN_GREEN, color: "black" }}
        onClick={() =>
          setSystem(system === SYSTEMS[0] ? SYSTEMS[1] : SYSTEMS[0])
        }
      >
        {system}
      </Badge>
    </>
  );
};
